module.exports = __webpack_public_path__ + "static/media/cleopatraenterprise.54d2ce1c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/cleopatraenterprise.webp
// module id = 410
// module chunks = 0